import React from "react";
import { useSelector } from "react-redux";
import Loader from "@druva-apps/orion/lib/loader";
import { selectShow } from "slices/fullPageLoaderSlice";

const FullPageLoader = () => {
  const show = useSelector(selectShow);
  return <Loader isLoading={show} fullPage />;
};

export default FullPageLoader;
